







import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"
import {ActiveProvide} from "@/support/reactive"

// TODO: Deprecate this with a classified regular table cell in JDS 4.

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsToolbar}
})
export default class JdsTableToolbarCell extends Vue {
    @ActiveProvide('jds.button.micro') buttonMicro = true;
}
